<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Produkty</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/products">Produkty</router-link>
        </li>
        <li class="active">
          <strong>Edycja</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div v-if="productObj" class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [pl]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_pl" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_pl"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_pl"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [en]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_en" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_en"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_en[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_en"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [de]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_de" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_de"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_de[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_de"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [de_de]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_cpde"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_cpde"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [de_en]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_cpen"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_cpen"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="canViewQuantity" class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Nakłady</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <button
                v-if="canAddQuantity"
                @click="startNewQuantity"
                :disabled="!!newQuantity"
                class="btn btn-sm btn-primary"
              >
                Dodaj
              </button>
              <button
                v-if="productObj.quantities?.length"
                @click="exportFile"
                :disabled="exportPricesLoading"
                class="btn btn-sm btn-primary"
              >
                <span v-if="exportPricesLoading">
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
                <span v-else>
                  <i class="fa fa-file-excel-o"></i>
                </span>
                Eksportuj
              </button>
              <button
                v-if="canAddProduct"
                @click="importFile = true"
                class="btn btn-sm btn-primary"
              >
                <i class="fa fa-cloud-upload"></i>
                Importuj
              </button>
              <div class="table-responsive m-t-sm">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th v-for="col in quantityCols" :key="col.value">
                        {{ col.title }}
                      </th>
                      <th>Akcje</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="newQuantity">
                      <td v-for="col in quantityCols" :key="col.value">
                        <input
                          v-model="newQuantity[col.value]"
                          type="number"
                          :min="col.min"
                          class="form-control inputClass"
                          :placeholder="col.title"
                        />
                        <div
                          v-if="quantityErrors.new?.[col.value]"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ quantityErrors.new[col.value][0] }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <button
                          @click="saveNewQuantity"
                          :disabled="quantitySaving"
                          class="btn btn-success btn-xs"
                          title="Zapisz"
                        >
                          <i class="fa fa-check" aria-hidden="true"></i>
                        </button>
                        <button
                          @click="cancelQuantity"
                          class="btn btn-danger btn-xs"
                          title="Anuluj"
                        >
                          <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-for="item in productObj.quantities" :key="item.pk">
                      <td v-for="col in quantityCols" :key="col.value">
                        <template v-if="editingQuantityPk === item.pk">
                          <input
                            v-model="quantityDraft[col.value]"
                            type="number"
                            :min="col.min"
                            class="form-control inputClass"
                            :placeholder="col.title"
                          />
                          <div
                            v-if="quantityErrors[item.pk]?.[col.value]"
                            class="has-error"
                          >
                            <span class="help-block">
                              {{ quantityErrors[item.pk][col.value][0] }}
                            </span>
                          </div>
                        </template>
                        <template v-else>
                          {{ item[col.value] ?? "---" }}
                        </template>
                      </td>
                      <td>
                        <template v-if="editingQuantityPk === item.pk">
                          <button
                            @click="saveQuantity(item)"
                            :disabled="quantitySaving"
                            class="btn btn-success btn-xs"
                            title="Zapisz"
                          >
                            <i class="fa fa-check" aria-hidden="true"></i>
                          </button>
                          <button
                            @click="cancelQuantityEdit"
                            class="btn btn-danger btn-xs"
                            title="Anuluj"
                          >
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </button>
                        </template>
                        <template v-else>
                          <button
                            v-if="canChangeQuantity"
                            @click="startEditQuantity(item)"
                            class="btn btn-warning btn-xs"
                            title="Edytuj"
                          >
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </button>
                          <button
                            v-if="canDeleteQuantity"
                            @click="removeQuantity(item)"
                            class="btn btn-danger btn-xs"
                            title="Usuń"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                          <button
                            v-if="canViewOptionPrice"
                            @click="quantityPrices(item)"
                            class="btn btn-success btn-xs"
                            title="Ceny opcji w nakładach"
                          >
                            <i class="fa fa-cog" aria-hidden="true"></i>
                          </button>
                        </template>
                      </td>
                    </tr>
                    <tr v-if="!productObj.quantities?.length && !newQuantity">
                      <td
                        :colspan="quantityCols.length + 1"
                        class="text-center"
                      >
                        Brak nakładów.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Materiały</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Wersja polska</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_pl"
                    mode="single"
                    placeholder="Wersja polska"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_pl.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_pl.loading"
                    @search-change="materialSelects.materials_pl.onSearch"
                    @open="materialSelects.materials_pl.bindScroll"
                    @close="materialSelects.materials_pl.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Wersja angielska</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_en"
                    mode="single"
                    placeholder="Wersja angielska"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_en.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_en.loading"
                    @search-change="materialSelects.materials_en.onSearch"
                    @open="materialSelects.materials_en.bindScroll"
                    @close="materialSelects.materials_en.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Wersja niemiecka</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_de"
                    mode="single"
                    placeholder="Wersja niemiecka"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_de.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_de.loading"
                    @search-change="materialSelects.materials_de.onSearch"
                    @open="materialSelects.materials_de.bindScroll"
                    @close="materialSelects.materials_de.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Wersja niemiecka (de)
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_cpde"
                    mode="single"
                    placeholder="Wersja niemiecka (de)"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_cpde.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_cpde.loading"
                    @search-change="materialSelects.materials_cpde.onSearch"
                    @open="materialSelects.materials_cpde.bindScroll"
                    @close="materialSelects.materials_cpde.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Wersja angielska (de)
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_cpen"
                    mode="single"
                    placeholder="Wersja angielska (de)"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_cpen.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_cpen.loading"
                    @search-change="materialSelects.materials_cpen.onSearch"
                    @open="materialSelects.materials_cpen.bindScroll"
                    @close="materialSelects.materials_cpen.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="canViewOptionGroup" class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Grupy opcji</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <button
                v-if="canAddOptionGroup"
                @click="addGroupOptions"
                class="btn btn-sm btn-primary"
              >
                Dodaj
              </button>
              <button
                v-if="canAddProduct"
                @click="importFileProd = true"
                class="btn btn-sm btn-primary"
              >
                <i class="fa fa-cloud-upload"></i>
                Importuj
              </button>
              <div class="table-responsive m-t-sm">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th class="drag-column"></th>
                      <th>ID</th>
                      <th>Nazwa</th>
                      <th>Akcje</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-for="(group, groupIndex) in productObj.group_options"
                      :key="group.group_option"
                    >
                      <tr
                        draggable="true"
                        @dragstart="onGroupDragStart(groupIndex)"
                        @dragover.prevent
                        @drop.prevent="onGroupDrop(groupIndex)"
                      >
                        <td
                          class="drag-column"
                          title="Przeciągnij, aby zmienić kolejność"
                        >
                          <i class="fa fa-bars"></i>
                        </td>
                        <td>{{ group.group_option }}</td>
                        <td>{{ group.group_option_name }}</td>
                        <td>
                          <button
                            @click="toggleGroup(group)"
                            class="btn btn-default btn-xs"
                            title="Opcje"
                          >
                            <span v-if="isGroupExpanded(group)">
                              <i class="fa fa-chevron-up"></i>
                            </span>
                            <span v-else>
                              <i class="fa fa-chevron-down"></i>
                            </span>
                          </button>
                          <button
                            v-if="canDeleteOptionGroup"
                            @click="removeGroup(group)"
                            class="btn btn-danger btn-xs"
                            title="Usuń"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="isGroupExpanded(group)">
                        <td></td>
                        <td colspan="3">
                          <h5>Opcje</h5>
                          <button
                            v-if="canAddOption"
                            @click="openOptionsModal(group)"
                            class="btn btn-sm btn-primary"
                          >
                            Dodaj
                          </button>
                          <table class="table table-bordered m-t-sm">
                            <thead>
                              <tr>
                                <th class="drag-column"></th>
                                <th>ID</th>
                                <th>Nazwa</th>
                                <th>Akcje</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(option, optionIndex) in group.options"
                                :key="option.option"
                                draggable="true"
                                @dragstart.stop="
                                  onOptionDragStart(group, optionIndex)
                                "
                                @dragover.prevent
                                @drop.prevent.stop="
                                  onOptionDrop(group, optionIndex)
                                "
                              >
                                <td
                                  class="drag-column"
                                  title="Przeciągnij, aby zmienić kolejność"
                                >
                                  <i class="fa fa-bars"></i>
                                </td>
                                <td>{{ option.option }}</td>
                                <td>{{ option.option_name }}</td>
                                <td>
                                  <button
                                    v-if="canDeleteOption"
                                    @click="removeOption(group, option)"
                                    class="btn btn-danger btn-xs"
                                    title="Usuń"
                                  >
                                    <i class="fa fa-trash"></i>
                                  </button>
                                  <button
                                    v-if="canViewOptionPrice"
                                    @click="groupPrices(option)"
                                    class="btn btn-success btn-xs"
                                    title="Ceny w zależności od nakładu"
                                  >
                                    <i class="fa fa-cog"></i>
                                  </button>
                                </td>
                              </tr>
                              <tr v-if="!group.options?.length">
                                <td colspan="4" class="text-center">
                                  Brak opcji.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="!productObj.group_options?.length">
                      <td colspan="4" class="text-center">Brak grup opcji.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Sprawdzanie pliku i podgląd</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">Typ produktu</label>
                <div v-if="options.length" class="col-sm-10">
                  <Multiselect
                    v-model="productObj.kind"
                    mode="single"
                    placeholder="Typ produktu"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="options"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.kind" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.kind[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Format</label>
                <div v-if="formats.length" class="col-sm-10">
                  <Multiselect
                    v-model="productObj.format"
                    mode="single"
                    placeholder="Format"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="formats"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.format" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.format[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Spad</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.bleed"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Spad"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.bleed" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.bleed[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Margines tekstu</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.text_margin"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Margines tekstu"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.text_margin"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.text_margin[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Grupa opcji określająca liczbę stron
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.option_group_for_page_count"
                    mode="single"
                    placeholder="Grupa opcji określająca liczbę stron"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="groupOptionsForPageNum"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.option_group_for_page_count"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.option_group_for_page_count[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Grupa opcji określająca liczbę stron okładki
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.option_group_for_cover_page_count"
                    mode="single"
                    placeholder="Grupa opcji określająca liczbę stron okładki"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="groupOptionsForPageNum"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.from_warehouse"
                        type="checkbox"
                      />
                      <span>Produkt z magazynu</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Konfiguracja produktu</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">Grupa pakowania</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.package"
                    mode="single"
                    placeholder="Grupa pakowania"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="packages"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.package" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.package[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Kategorie</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.categories"
                    mode="tags"
                    placeholder="Kategorie"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="categories"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.categories"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.categories[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Jak przygotować</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.page"
                    mode="single"
                    placeholder="Jak przygotować"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="pages"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Zastosowania</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.appliances"
                    mode="tags"
                    placeholder="Zastosowania"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="appliances"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Dostępność w sklepach
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.available_in_countries"
                    mode="tags"
                    placeholder="Dostępność w sklepach"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="countries"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.available_in_countries"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.available_in_countries[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="parameters?.length" class="form-group">
                <label class="col-sm-2 control-label">Parametry</label>
                <div class="col-sm-5">
                  <div class="listbox1">
                    <h4>Nie wybrane</h4>
                    <ejs-listbox
                      :dataSource="filteredParams"
                      :fields="fields"
                      scope="#listbox"
                      :toolbarSettings="toolbarSettings"
                      :allowFiltering="true"
                      filterBarPlaceholder="Filtruj!"
                      @filtering="onFiltering"
                    ></ejs-listbox>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="listbox2">
                    <h4>Wybrane</h4>
                    <ejs-listbox
                      :dataSource="selFilteredParameters"
                      id="listbox"
                      :fields="fields"
                      scope="combined-list"
                      @change="onItemChange"
                      :allowFiltering="true"
                      filterBarPlaceholder="Filtruj!"
                      @filtering="onFilteringSel"
                    >
                    </ejs-listbox>
                    <ejs-tooltip
                      ref="tooltipRef"
                      target=".listbox2 li.e-list-item"
                      position="LeftCenter"
                      opensOn="Custom"
                      :width="'300px'"
                      @afterOpen="onTooltipAfterOpen"
                    ></ejs-tooltip>
                  </div>
                </div>
              </div>
              <div v-if="pOptions.length" class="form-group">
                <label class="col-sm-2 control-label">
                  Opcje przypisane do produktu
                </label>
                <div class="col-sm-5">
                  <div class="listbox1">
                    <h4>Nie wybrane</h4>
                    <ejs-listbox
                      :dataSource="pOptionsFiltered"
                      :fields="fields"
                      scope="#listbox1"
                      @actionComplete="syncSelectedOptions"
                      :toolbarSettings="toolbarSettings"
                      :allowFiltering="true"
                      filterBarPlaceholder="Filtruj!"
                      @filtering="onFilteringP"
                    ></ejs-listbox>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="listbox2">
                    <h4>Wybrane</h4>
                    <ejs-listbox
                      id="listbox1"
                      @actionComplete="syncSelectedOptions"
                      :dataSource="pOptionsSelFiltered"
                      :fields="fields"
                      :allowFiltering="true"
                      filterBarPlaceholder="Filtruj!"
                      @filtering="onFilteringPSel"
                    >
                    </ejs-listbox>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Termin realizacji</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.deadline"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Termin realizacji"
                  />
                  <div v-if="errorsAdminData?.data?.deadline" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.deadline[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Deadline</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.deadline_time"
                    type="time"
                    step="1"
                    class="form-control inputClass"
                    placeholder="Deadline"
                  />
                  <div
                    v-if="errorsAdminData?.data?.deadline_time"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.deadline_time[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Grupa opcji określająca termin realizacji
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.option_group_for_deadline"
                    mode="single"
                    placeholder="Grupa opcji określająca termin realizacji"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="groupOptionsForPageNum"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Waga jednostkowa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.unit_weight"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Waga jednostkowa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.unit_weight"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.unit_weight[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.horizontal"
                        name="horizontal"
                        type="checkbox"
                      />
                      <span>Orientacja pozioma</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.is_published"
                        name="is_published"
                        type="checkbox"
                      />
                      <span>Opublikowany</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.is_popular"
                        name="is_popular"
                        type="checkbox"
                      />
                      <span>Wyświetlaj w najpopularniejszych produktach</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.frozen_price"
                        name="frozen_price"
                        type="checkbox"
                      />
                      <span>Zamrożona cena</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.imposition"
                        name="imposition"
                        type="checkbox"
                      />
                      <span>Do impozycji</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.exclusive_sheet"
                        name="exclusive_sheet"
                        type="checkbox"
                      />
                      <span>Wyłączność na arkuszu</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Obrazek</label>
                <div class="col-sm-10">
                  <!-- Same layout as cp-input-file of the old panel: a
                       preview with "Wybierz plik" / "Zmień" and "Usuń". -->
                  <div class="product-image-input">
                    <div
                      class="thumbnail product-image-preview"
                      @click="openImagePicker"
                    >
                      <img v-if="imagePreview" :src="imagePreview" alt="" />
                    </div>
                    <div>
                      <span class="btn btn-default" @click="openImagePicker">
                        {{ imagePreview ? "Zmień" : "Wybierz plik" }}
                      </span>
                      <a
                        v-if="imagePreview"
                        href="#"
                        class="btn btn-default"
                        @click.prevent="removePhoto"
                      >
                        Usuń
                      </a>
                      <input
                        ref="imageInput"
                        type="file"
                        accept="image/*"
                        style="display: none"
                        @change="changePhoto"
                      />
                    </div>
                  </div>
                  <div v-if="errorsAdminData?.data?.image" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.image[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="canViewGallery" class="form-group">
                <label class="control-label col-sm-2">Galeria</label>
                <div class="col-sm-10">
                  <div
                    class="product-gallery"
                    :class="{
                      'product-gallery-clickable': canAddGallery,
                      'product-gallery-dragover': galleryDragOver,
                    }"
                    @click="openGalleryPicker"
                    @dragover.prevent="onGalleryDragOver"
                    @dragleave.prevent="galleryDragOver = false"
                    @drop.prevent="onGalleryDrop"
                  >
                    <div
                      v-for="image in productObj.gallery || []"
                      :key="image.pk"
                      class="product-gallery-item"
                      @click.stop
                    >
                      <a :href="image.image" target="_blank">
                        <img :src="image.image" alt="" />
                      </a>
                      <button
                        v-if="canDeleteGallery"
                        @click="deleteGalleryImage(image)"
                        class="btn btn-danger btn-xs product-gallery-remove"
                        title="Usuń"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                    <p v-if="!productObj.gallery?.length" class="text-muted">
                      Dodaj zdjęcia do galerii.
                    </p>
                  </div>
                  <input
                    v-if="canAddGallery"
                    ref="galleryInput"
                    type="file"
                    accept="image/*"
                    multiple
                    style="display: none"
                    @change="uploadGalleryImages"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Data od</label>
                <div class="col-sm-10">
                  <VueDatePicker :format="format" v-model="date_from" />
                  <div
                    v-if="errorsAdminData?.data?.date_from"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.date_from[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Data do</label>
                <div class="col-sm-10">
                  <VueDatePicker :format="format" v-model="date_to" />
                  <div v-if="errorsAdminData?.data?.date_to" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.date_to[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.is_available_on_allegro"
                        type="checkbox"
                      />
                      <span>
                        Dostępny dla ofert Allegro (w kreatorze ofert)
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/products">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canChangeProduct"
                    @click="saveEdit"
                    class="btn btn-primary"
                  >
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mGroups" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Dodaj grupy opcji</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-10">
                  <Multiselect
                    v-model="groupsToAdd"
                    mode="tags"
                    placeholder="Grupy opcji"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="availableGroups"
                    :hideSelected="true"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mGroups = false" class="btn btn-white">Anuluj</button>
          <button @click="addGroup()" class="btn btn-primary">Dodaj</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mGroups" @click="mGroups = false" class="modal-backdrop"></div>
  <div v-if="mOptions" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Dodaj opcje</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-10">
                  <Multiselect
                    v-model="optionsToAdd"
                    mode="tags"
                    placeholder="Opcje"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="availableGroupOptions"
                    :hideSelected="true"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mOptions = false" class="btn btn-white">
            Anuluj
          </button>
          <button @click="addOption()" class="btn btn-primary">Dodaj</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mOptions" @click="mOptions = false" class="modal-backdrop"></div>
  <div v-if="mQuantityPrices" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Ceny opcji w nakładach</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12">
                  <table class="options-table" width="100%">
                    <thead>
                      <th>ID</th>
                      <th>Opcja</th>
                      <th>Cena</th>
                      <th>Akcja</th>
                    </thead>
                    <tbody>
                      <tr v-for="row in quantityPriceRows" :key="row.pk">
                        <td>{{ row.pk }}</td>
                        <td>{{ row.option }}</td>
                        <td class="text-center">
                          <input
                            v-if="editingPricePk === row.pk"
                            v-model="priceDraft"
                            type="number"
                            min="0"
                            class="form-control inputClass"
                            placeholder="Cena"
                          />
                          <span v-else>{{ row.price }}</span>
                        </td>
                        <td class="float-e-margins text-center">
                          <div v-if="editingPricePk === row.pk">
                            <button
                              class="btn btn-success"
                              type="button"
                              title="Zapisz"
                              @click="savePriceDetail(row)"
                            >
                              <font-awesome-icon
                                icon="check"
                                class="table-helper-item"
                              />
                            </button>
                            <button
                              class="btn btn-danger btn-xs"
                              type="button"
                              title="Anuluj"
                              @click="editingPricePk = null"
                            >
                              <font-awesome-icon
                                icon="times"
                                class="table-helper-item"
                              />
                            </button>
                          </div>
                          <button
                            v-else-if="canChangeOptionPrice"
                            class="btn btn-warning"
                            title="Edytuj"
                            type="button"
                            @click="startEditPrice(row)"
                          >
                            <font-awesome-icon
                              icon="pencil"
                              class="table-helper-item"
                            />
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mQuantityPrices = false" class="btn btn-primary">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="mQuantityPrices"
    @click="mQuantityPrices = false"
    class="modal-backdrop"
  />
  <div v-if="mGroupPrices" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Ceny w zależności od nakładu</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12">
                  <table class="options-table" width="100%">
                    <thead>
                      <th>Nakład</th>
                      <th>Cena</th>
                      <th>Akcja</th>
                    </thead>
                    <tbody>
                      <tr v-for="row in optionPriceRows" :key="row.pk">
                        <td>{{ row.quantity }}</td>
                        <td class="text-center">
                          <input
                            v-if="editingOptionPricePk === row.pk"
                            v-model="optionPriceDraft"
                            type="number"
                            min="0"
                            class="form-control inputClass"
                            placeholder="Cena"
                          />
                          <span v-else>{{ row.price }}</span>
                        </td>
                        <td class="float-e-margins text-center">
                          <div v-if="editingOptionPricePk === row.pk">
                            <button
                              class="btn btn-success"
                              type="button"
                              title="Zapisz"
                              @click="saveOptionPrice(row)"
                            >
                              <font-awesome-icon
                                icon="check"
                                class="table-helper-item"
                              />
                            </button>
                            <button
                              class="btn btn-danger btn-xs"
                              type="button"
                              title="Anuluj"
                              @click="editingOptionPricePk = null"
                            >
                              <font-awesome-icon
                                icon="times"
                                class="table-helper-item"
                              />
                            </button>
                          </div>
                          <button
                            v-else-if="canChangeOptionPrice"
                            class="btn btn-warning"
                            title="Edytuj"
                            type="button"
                            @click="startEditOptionPrice(row)"
                          >
                            <font-awesome-icon
                              icon="pencil"
                              class="table-helper-item"
                            />
                          </button>
                        </td>
                      </tr>
                      <tr v-if="!optionPriceRows.length">
                        <td colspan="3" class="text-center">
                          Produkt nie ma nakładów.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mGroupPrices = false" class="btn btn-primary">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="mGroupPrices"
    @click="mGroupPrices = false"
    class="modal-backdrop"
  />

  <div v-if="importFile" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Import nakładów i cen opcji</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="excel_file" class="col-sm-2 control-label">
              Plik excel
            </label>
            <div class="col-sm-10">
              <div class="fileinput fileinput-new input-group">
                <div class="form-control">
                  <input type="file" name="file" v-on:change="onFileChange" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="unassignedRows.length" class="table-responsive m-t-md">
            <h5>Nieprzypisane wpisy</h5>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th v-for="col in unassignedCols" :key="col.value">
                    {{ col.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in unassignedRows" :key="index">
                  <td v-for="col in unassignedCols" :key="col.value">
                    {{ row[col.value] ?? "—" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeImportPrices" class="btn btn-white">
            Anuluj
          </button>
          <button
            @click="importFileFn()"
            :disabled="!excelFile || importPricesUploading"
            class="btn btn-primary"
          >
            <span v-if="importPricesUploading">
              <i class="fa fa-spinner fa-spin"></i>
            </span>
            <span v-else>Importuj</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="importFile" class="modal-backdrop"></div>

  <div v-if="importFileProd" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Import operacji grup/opcji produktu</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="excel_file" class="col-sm-2 control-label">
              Produkt
            </label>
            <div class="col-sm-10">
              <div class="fileinput fileinput-new input-group">
                <div class="form-control">
                  <Multiselect
                    v-model="importProduct"
                    mode="single"
                    placeholder="Produkt"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="importProductSelect.options"
                    :filter-results="false"
                    :loading="importProductSelect.loading"
                    @search-change="importProductSelect.onSearch"
                    @open="importProductSelect.bindScroll"
                    @close="importProductSelect.unbindScroll"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="importFileProd = false" class="btn btn-white">
            Anuluj
          </button>
          <button
            @click="importFileProdFn()"
            :disabled="!importProduct || applyLogLoading"
            class="btn btn-primary"
          >
            <span v-if="applyLogLoading">
              <i class="fa fa-spinner fa-spin"></i>
            </span>
            <span v-else>Importuj</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="importFileProd" class="modal-backdrop"></div>
</template>

<script>
import { computed, nextTick, reactive, ref, watch, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { usePagedSelect } from "../../composables/usePagedSelect";
import { hasPermission } from "../../permissions";
import {
  productOptionGroupPermissionsConst,
  productOptionPermissionsConst,
  productgalleryPermissionsConst,
  productoptionpricePermissionsConst,
  productPermissionsConst,
  productQuantityPermissionsConst,
} from "../../constants/productConstants";
import router from "../../router/router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { useRoute } from "vue-router";
import { ListBoxComponent as EjsListbox } from "@syncfusion/ej2-vue-dropdowns";
import { TooltipComponent as EjsTooltip } from "@syncfusion/ej2-vue-popups";
import { Query } from "@syncfusion/ej2-data";
import "/node_modules/@syncfusion/ej2-base/styles/material.css";
import "/node_modules/@syncfusion/ej2-inputs/styles/material.css";
import "/node_modules/@syncfusion/ej2-dropdowns/styles/material.css";

export default {
  name: "ProductsEdit",
  mixins: [],
  components: {
    Multiselect,
    EjsListbox,
    EjsTooltip,
  },
  props: {},

  setup() {
    const productObj = ref({
      name: "",
      model: "",
      type: "",
      image: "",
      categories: [],
      quantities: [],
      options: [],
      group_options: [],
      parameters: [],
    });

    const countries = ref(["PL", "DE"]);
    const options = ref([]);
    const formats = ref([]);
    const packages = ref([]);
    const categories = ref([]);
    const pages = ref([]);
    const appliances = ref([]);
    const parameters = ref([]);
    const filteredParams = ref();
    const filteredOptions = ref();
    const selParameters = ref([]);
    const selFilteredParameters = ref([]);
    const pOptions = ref([]);
    const pOptionsFiltered = ref([]);
    const pOptionsSelFiltered = ref([]);
    const selectedOptions = ref([]);
    const errorsAdminData = ref();
    const date_from = ref();
    const date_to = ref();
    const mGroups = ref(false);
    const mGroupPrices = ref(false);
    const groupPricesPk = ref();
    const mQuantityPrices = ref(false);
    const quantityPk = ref();
    const importProduct = ref();
    const mOptions = ref(false);
    const isEdit = ref(false);
    const paramOptions = ref([]);
    const showErrors = ref(false);
    const importFile = ref(false);
    const importFileProd = ref(false);
    const excelFile = ref("");
    const route = useRoute();
    const store = useStore();
    // The price and log imports are POST endpoints, for which the backend
    // checks the add permission.
    const canAddProduct = computed(() =>
      hasPermission(productPermissionsConst.add)
    );
    const canChangeProduct = computed(() =>
      hasPermission(productPermissionsConst.update)
    );
    // Quantities, option groups, options and option prices are separate models
    // in the old panel, each section gated by its own permissions.
    const canViewQuantity = computed(() =>
      hasPermission(productQuantityPermissionsConst.view)
    );
    const canAddQuantity = computed(() =>
      hasPermission(productQuantityPermissionsConst.add)
    );
    const canChangeQuantity = computed(() =>
      hasPermission(productQuantityPermissionsConst.update)
    );
    const canDeleteQuantity = computed(() =>
      hasPermission(productQuantityPermissionsConst.delete)
    );
    const canViewOptionGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.view)
    );
    const canAddOptionGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.add)
    );
    const canDeleteOptionGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.delete)
    );
    const canAddOption = computed(() =>
      hasPermission(productOptionPermissionsConst.add)
    );
    const canDeleteOption = computed(() =>
      hasPermission(productOptionPermissionsConst.delete)
    );
    // The gallery is a separate model saved right away, like the dropzone of
    // the old product update view.
    const canViewGallery = computed(() =>
      hasPermission(productgalleryPermissionsConst.view)
    );
    const canAddGallery = computed(() =>
      hasPermission(productgalleryPermissionsConst.add)
    );
    const canDeleteGallery = computed(() =>
      hasPermission(productgalleryPermissionsConst.delete)
    );
    const canViewOptionPrice = computed(() =>
      hasPermission(productoptionpricePermissionsConst.view)
    );
    const canChangeOptionPrice = computed(() =>
      hasPermission(productoptionpricePermissionsConst.update)
    );
    const updateProductsData = computed(
      () => store.getters.getUpdateProductsData
    );
    const productOptionsData = computed(
      () => store.getters.getProductOptionsData
    );
    const pagesData = computed(() => store.getters.getProductPagesData);
    const parametersData = computed(() => store.getters.getAdminParametersData);
    const productData = computed(() => store.getters.getProductData);
    const paOptionsGroupData = computed(
      () => store.getters.getpaOptionsGroupData
    );
    const adminProductOptionsData = computed(
      () => store.getters.getAdminProductOptionsData
    );
    const updatePriceDetailData = computed(
      () => store.getters.getUpdatePriceDetailData
    );
    const fields = { text: "Name", value: "Code" };
    const toolbarSettings = {
      items: ["moveTo", "moveFrom", "moveAllTo", "moveAllFrom"],
    };
    const normalizeOptionId = (id) => {
      const numericId = Number(id);
      return Number.isNaN(numericId) ? id : numericId;
    };
    let quantityPriceHeaders = [
      { text: "ID", value: "pk", sortable: true },
      {
        text: "Opcja",
        value: "option",
        sortable: true,
      },
      {
        text: "Cena",
        value: "price",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];
    // The deadline is a time field accepting HH:MM:SS only - a time input may
    // give HH:MM, and an empty one means no deadline, like the old timepicker.
    const normalizeDeadlineTime = (value) => {
      if (!value) {
        return null;
      }
      return /^\d{2}:\d{2}$/.test(value) ? value + ":00" : value;
    };

    const saveEdit = () => {
      if (!canChangeProduct.value) {
        return;
      }
      showErrors.value = true;
      let listboxobj = document.getElementById("listbox").ej2_instances[0];
      let selParams = listboxobj.getDataList();
      productObj.value.date_from = format(date_from.value);
      productObj.value.date_to = format(date_to.value);
      productObj.value.parameters = [];
      productObj.value.options = [];
      selParams.forEach((element) => {
        const existingParameter = (productObj.value.parameters || []).find(
          (obj) => String(obj.parameter) === String(element.Code)
        );
        const selectedOptions = Array.isArray(paramOptions.value[element.Code])
          ? paramOptions.value[element.Code]
          : existingParameter?.parameter_options || [];

        productObj.value.parameters.push({
          parameter: element.Code,
          parameter_options: selectedOptions.map((id) => normalizeOptionId(id)),
        });
      });
      let listboxobj1 = document.getElementById("listbox1").ej2_instances[0];
      let selOptions = listboxobj1.getDataList();
      selOptions.forEach((element) => {
        productObj.value.options.push(element.Code);
      });
      productObj.value.deadline_time = normalizeDeadlineTime(
        productObj.value.deadline_time
      );
      store.dispatch("updateProducts", productObj.value);
    };

    // Mirrors the quantities table of the old product update view - quantities
    // are not part of the product update, so every row is saved right away
    // through the quantities endpoints.
    const quantityCols = [
      { title: "Nakład", value: "quantity", required: true, min: 1 },
      {
        title: "Nakład widoczny",
        value: "display_quantity",
        required: true,
        min: 1,
      },
      { title: "Cena", value: "price", required: true, min: 0 },
      {
        title: "Dni realizacji",
        value: "realization_days",
        required: false,
        min: 0,
      },
    ];
    const newQuantity = ref(null);
    const editingQuantityPk = ref(null);
    const quantityDraft = ref({});
    const quantityErrors = ref({});
    const quantitySaving = ref(false);

    const isEmptyValue = (value) =>
      value === "" || value === null || value === undefined;

    const validateQuantity = (row) => {
      const errors = {};
      quantityCols.forEach((col) => {
        if (col.required && isEmptyValue(row[col.value])) {
          errors[col.value] = ["To pole musi być wypełnione!"];
        }
      });
      return errors;
    };

    const quantityPayload = (row) => {
      const payload = { product: productObj.value.pk };
      quantityCols.forEach((col) => {
        if (!isEmptyValue(row[col.value])) {
          payload[col.value] = row[col.value];
        }
      });
      return payload;
    };

    const setQuantityErrors = (key, errors) => {
      quantityErrors.value = { ...quantityErrors.value, [key]: errors };
    };

    const showResponseError = (error) => {
      const data = error?.response?.data || {};
      const [first] = Object.entries(data);
      store.dispatch("showToaster", {
        type: "error",
        content: first
          ? first[0] + ": " + first[1]
          : "Wystąpił błąd podczas zapisu.",
      });
    };

    const startNewQuantity = () => {
      if (!canAddQuantity.value || newQuantity.value) {
        return;
      }
      newQuantity.value = {
        quantity: "",
        display_quantity: "",
        price: "",
        realization_days: "",
      };
      setQuantityErrors("new", {});
    };

    const cancelQuantity = () => {
      newQuantity.value = null;
      setQuantityErrors("new", {});
    };

    const saveNewQuantity = () => {
      if (!canAddQuantity.value || !newQuantity.value || quantitySaving.value) {
        return;
      }
      const errors = validateQuantity(newQuantity.value);
      setQuantityErrors("new", errors);
      if (Object.keys(errors).length) {
        return;
      }

      quantitySaving.value = true;
      store
        .dispatch("createQuantity", quantityPayload(newQuantity.value))
        .then((response) => {
          productObj.value.quantities = [
            ...(productObj.value.quantities || []),
            response.data,
          ];
          newQuantity.value = null;
          store.dispatch("showToaster", {
            type: "success",
            content: "Pomyślnie dodano nakład do produktu!",
          });
        })
        .catch((error) => {
          setQuantityErrors("new", error?.response?.data || {});
          showResponseError(error);
        })
        .finally(() => {
          quantitySaving.value = false;
        });
    };

    const startEditQuantity = (item) => {
      if (!canChangeQuantity.value) {
        return;
      }
      editingQuantityPk.value = item.pk;
      quantityDraft.value = { ...item };
      setQuantityErrors(item.pk, {});
    };

    const cancelQuantityEdit = () => {
      editingQuantityPk.value = null;
      quantityDraft.value = {};
    };

    const saveQuantity = (item) => {
      if (!canChangeQuantity.value || quantitySaving.value) {
        return;
      }
      const errors = validateQuantity(quantityDraft.value);
      setQuantityErrors(item.pk, errors);
      if (Object.keys(errors).length) {
        return;
      }

      quantitySaving.value = true;
      store
        .dispatch("updateQuantity", {
          pk: item.pk,
          ...quantityPayload(quantityDraft.value),
        })
        .then((response) => {
          productObj.value.quantities = productObj.value.quantities.map(
            (quantity) => (quantity.pk === item.pk ? response.data : quantity)
          );
          cancelQuantityEdit();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane nakładu zostały zaktualizowane!",
          });
        })
        .catch((error) => {
          setQuantityErrors(item.pk, error?.response?.data || {});
          showResponseError(error);
        })
        .finally(() => {
          quantitySaving.value = false;
        });
    };

    // Option prices of one quantity - every option picked in the product's
    // groups, with 0 when no price was saved yet, like in the old panel.
    const editingPricePk = ref(null);
    const priceDraft = ref(0);

    const quantityPriceRows = computed(() => {
      if (!quantityPk.value) {
        return [];
      }
      return (productObj.value.group_options || [])
        .flatMap((group) => group.options || [])
        .map((item) => {
          const optionId = item.option ?? item.pk;
          const price = (productObj.value.option_prices || []).find(
            (optionPrice) =>
              optionPrice.product === productObj.value.pk &&
              optionPrice.product_option === optionId &&
              optionPrice.product_quantity === quantityPk.value
          );
          return {
            pk: optionId,
            option: item.option_name ?? item.name,
            price: price ? parseFloat(price.price) : 0,
          };
        });
    });

    // Option groups of the product - mirrors the group options table of the old
    // product views: groups keep the backend shape
    // {group_option, group_option_name, options: [{option, option_name,
    // position}]} and are saved together with the product.
    const expandedGroupIds = ref([]);
    const groupsToAdd = ref([]);
    const optionsToAdd = ref([]);
    const optionsModalGroup = ref(null);
    const draggedGroupIndex = ref(null);
    const draggedOption = ref(null);

    // Groups with their options, the list productGroupOptions gives the old
    // panel.
    const groupOptionsList = computed(() =>
      paOptionsGroupData.value?.status === 200 &&
      Array.isArray(paOptionsGroupData.value.data)
        ? paOptionsGroupData.value.data
        : []
    );
    const optionsList = computed(() =>
      adminProductOptionsData.value?.status === 200 &&
      Array.isArray(adminProductOptionsData.value.data)
        ? adminProductOptionsData.value.data
        : []
    );

    const availableGroups = computed(() => {
      const assigned = (productObj.value.group_options || []).map(
        (group) => group.group_option
      );
      return groupOptionsList.value
        .filter((group) => !assigned.includes(group.pk))
        .map((group) => ({
          name: `[${group.pk}] ${group.name}`,
          value: group.pk,
        }));
    });

    const availableGroupOptions = computed(() => {
      const row = optionsModalGroup.value;
      if (!row) {
        return [];
      }
      const group = groupOptionsList.value.find(
        (item) => item.pk === row.group_option
      );
      const assigned = (row.options || []).map((option) => option.option);
      return (group?.product_options || [])
        .filter((option) => !assigned.includes(option.pk))
        .map((option) => ({
          name: `[${option.pk}] ${option.label}`,
          value: option.pk,
        }));
    });

    // The page count, cover page count and deadline selects offer the groups
    // assigned to the product plus the groups of its directly assigned options,
    // like getGroupOptionsForPageNum in the old panel.
    const groupOptionsForPageNum = computed(() => {
      const allowed = new Set(
        (productObj.value.group_options || []).map(
          (group) => group.group_option
        )
      );
      (productObj.value.options || []).forEach((optionPk) => {
        const option = optionsList.value.find((item) => item.pk === optionPk);
        if (option) {
          allowed.add(option.options_group);
        }
      });
      return groupOptionsList.value
        .filter((group) => allowed.has(group.pk))
        .sort((a, b) => a.pk - b.pk)
        .map((group) => ({
          name: `[${group.pk}] ${group.name}`,
          value: group.pk,
        }));
    });

    const isGroupExpanded = (group) =>
      expandedGroupIds.value.includes(group.group_option);

    const toggleGroup = (group) => {
      expandedGroupIds.value = isGroupExpanded(group)
        ? expandedGroupIds.value.filter((pk) => pk !== group.group_option)
        : [...expandedGroupIds.value, group.group_option];
    };

    const addGroupOptions = () => {
      if (!canAddOptionGroup.value) {
        return;
      }
      groupsToAdd.value = [];
      mGroups.value = true;
    };

    const addGroup = () => {
      if (!canAddOptionGroup.value) {
        return;
      }
      if (!Array.isArray(productObj.value.group_options)) {
        productObj.value.group_options = [];
      }
      groupsToAdd.value.forEach((groupPk) => {
        const group = groupOptionsList.value.find(
          (item) => item.pk === groupPk
        );
        if (group) {
          productObj.value.group_options.push({
            group_option: group.pk,
            group_option_name: group.name,
            options: [],
          });
        }
      });
      groupsToAdd.value = [];
      mGroups.value = false;
    };

    const removeGroup = (group) => {
      if (!canDeleteOptionGroup.value) {
        return;
      }
      productObj.value.group_options = productObj.value.group_options.filter(
        (item) => item.group_option !== group.group_option
      );
      expandedGroupIds.value = expandedGroupIds.value.filter(
        (pk) => pk !== group.group_option
      );
    };

    const openOptionsModal = (group) => {
      if (!canAddOption.value) {
        return;
      }
      optionsModalGroup.value = group;
      optionsToAdd.value = [];
      mOptions.value = true;
    };

    const addOption = () => {
      const row = optionsModalGroup.value;
      if (!canAddOption.value || !row) {
        return;
      }
      const group = groupOptionsList.value.find(
        (item) => item.pk === row.group_option
      );
      if (!Array.isArray(row.options)) {
        row.options = [];
      }
      optionsToAdd.value.forEach((optionPk) => {
        const option = (group?.product_options || []).find(
          (item) => item.pk === optionPk
        );
        if (option) {
          row.options.push({
            option: option.pk,
            option_name: option.label,
            position: row.options.length,
          });
        }
      });
      optionsToAdd.value = [];
      optionsModalGroup.value = null;
      mOptions.value = false;
    };

    // Option groups are sent as a whole with the product, so removing the
    // option locally is enough - saving the product drops it.
    const removeOption = (group, option) => {
      if (!canDeleteOption.value) {
        return;
      }
      group.options = (group.options || []).filter(
        (item) => item.option !== option.option
      );
    };

    // Reordering numbers the positions from 1, like the reorder handlers of
    // the old panel; the positions are saved with the product.
    const onGroupDragStart = (index) => {
      draggedGroupIndex.value = index;
    };

    const onGroupDrop = (index) => {
      const from = draggedGroupIndex.value;
      draggedGroupIndex.value = null;
      if (from === null || from === index) {
        return;
      }
      const groups = [...productObj.value.group_options];
      const [moved] = groups.splice(from, 1);
      groups.splice(index, 0, moved);
      groups.forEach((group, position) => {
        group.position = position + 1;
      });
      productObj.value.group_options = groups;
    };

    const onOptionDragStart = (group, index) => {
      draggedOption.value = { group: group.group_option, index };
    };

    const onOptionDrop = (group, index) => {
      const dragged = draggedOption.value;
      draggedOption.value = null;
      if (
        !dragged ||
        dragged.group !== group.group_option ||
        dragged.index === index
      ) {
        return;
      }
      const groupOptions = [...group.options];
      const [moved] = groupOptions.splice(dragged.index, 1);
      groupOptions.splice(index, 0, moved);
      groupOptions.forEach((option, position) => {
        option.position = position + 1;
      });
      group.options = groupOptions;
    };

    // Keeps productObj.options in step with the "selected" options listbox, so
    // the page count groups follow it like onProductOptionsChange does.
    const syncSelectedOptions = () => {
      nextTick(() => {
        const listbox = document.getElementById("listbox1")?.ej2_instances?.[0];
        if (listbox) {
          productObj.value.options = listbox
            .getDataList()
            .map((element) => element.Code);
        }
      });
    };

    const quantityPrices = (item) => {
      if (!canViewOptionPrice.value) {
        store.dispatch("showToaster", {
          type: "error",
          content: productoptionpricePermissionsConst.view.errorMsg,
        });
        return;
      }
      quantityPk.value = item.pk;
      editingPricePk.value = null;
      mQuantityPrices.value = true;
    };

    const startEditPrice = (row) => {
      if (!canChangeOptionPrice.value) {
        return;
      }
      editingPricePk.value = row.pk;
      priceDraft.value = row.price;
    };

    // Saves one option price right away - the endpoint creates the price when
    // it does not exist yet and returns every option price of the product.
    const putOptionPrice = (optionId, quantityId, price) =>
      store
        .dispatch("updatePriceDetail", {
          product_option: optionId,
          product_quantity: quantityId,
          product: productObj.value.pk,
          price,
        })
        .then((response) => {
          productObj.value.option_prices = response.data;
        });

    const savePriceDetail = (row) => {
      if (!canChangeOptionPrice.value) {
        return;
      }
      putOptionPrice(row.pk, quantityPk.value, priceDraft.value)
        .then(() => {
          editingPricePk.value = null;
        })
        .catch(() => {
          // The updatePriceDetailData watcher shows the error.
        });
    };

    // Prices of one option in every quantity of the product - mirrors
    // ProductOptionPricesByQuantityUpdate from the old admin panel.
    const editingOptionPricePk = ref(null);
    const optionPriceDraft = ref(0);

    const optionPriceRows = computed(() => {
      if (!groupPricesPk.value) {
        return [];
      }
      return (productObj.value.quantities || []).map((quantity) => {
        const price = (productObj.value.option_prices || []).find(
          (optionPrice) =>
            optionPrice.product === productObj.value.pk &&
            optionPrice.product_option === groupPricesPk.value &&
            optionPrice.product_quantity === quantity.pk
        );
        return {
          pk: quantity.pk,
          quantity: quantity.quantity,
          price: price ? parseFloat(price.price) : 0,
        };
      });
    });

    const startEditOptionPrice = (row) => {
      if (!canChangeOptionPrice.value) {
        return;
      }
      editingOptionPricePk.value = row.pk;
      optionPriceDraft.value = row.price;
    };

    const saveOptionPrice = (row) => {
      if (!canChangeOptionPrice.value) {
        return;
      }
      putOptionPrice(groupPricesPk.value, row.pk, optionPriceDraft.value)
        .then(() => {
          editingOptionPricePk.value = null;
        })
        .catch(() => {
          // The updatePriceDetailData watcher shows the error.
        });
    };

    // The gallery accepts dropped images or a click opening the file picker,
    // like the dropzone of the old panel.
    const galleryInput = ref(null);
    const galleryDragOver = ref(false);

    const openGalleryPicker = () => {
      if (canAddGallery.value) {
        galleryInput.value?.click();
      }
    };

    const onGalleryDragOver = () => {
      galleryDragOver.value = canAddGallery.value;
    };

    const onGalleryDrop = (event) => {
      galleryDragOver.value = false;
      uploadGalleryFiles(
        Array.from(event.dataTransfer?.files || []).filter((file) =>
          file.type.startsWith("image/")
        )
      );
    };

    const uploadGalleryImages = (event) => {
      const files = Array.from(event.target.files || []);
      event.target.value = "";
      uploadGalleryFiles(files);
    };

    const uploadGalleryFiles = (files) => {
      if (!canAddGallery.value) {
        return;
      }
      files.forEach((file) => {
        store
          .dispatch("createProductGalleryImage", {
            product: productObj.value.pk,
            image: file,
          })
          .then((response) => {
            productObj.value.gallery = [
              ...(productObj.value.gallery || []),
              response.data,
            ];
            store.dispatch("showToaster", {
              type: "success",
              content: "Do galerii zostało dodane nowe zdjęcie!",
            });
          })
          .catch(showResponseError);
      });
    };

    const deleteGalleryImage = (image) => {
      if (!canDeleteGallery.value) {
        return;
      }
      store
        .dispatch("deleteProductGalleryImage", image.pk)
        .then(() => {
          productObj.value.gallery = (productObj.value.gallery || []).filter(
            (item) => item.pk !== image.pk
          );
          store.dispatch("showToaster", {
            type: "success",
            content: "Zdjęcie zostało usunięte!",
          });
        })
        .catch(showResponseError);
    };

    const removeQuantityRow = (item) => {
      productObj.value.quantities = productObj.value.quantities.filter(
        (quantity) =>
          item.pk ? quantity.pk !== item.pk : quantity.id !== item.id
      );
    };

    // Quantities are not part of the product update, so an existing one is
    // deleted right away, like in the old panel.
    const removeQuantity = (item) => {
      if (!canDeleteQuantity.value) {
        return;
      }
      if (!item.pk) {
        removeQuantityRow(item);
        return;
      }
      if (!window.confirm("Czy na pewno chcesz usunąć ten nakład?")) {
        return;
      }
      store
        .dispatch("deleteQuantity", item.pk)
        .then(() => {
          removeQuantityRow(item);
          if (editingQuantityPk.value === item.pk) {
            cancelQuantityEdit();
          }
          store.dispatch("showToaster", {
            type: "success",
            content: "Nakład produktu został usunięty!",
          });
        })
        .catch((error) => {
          // Already gone on the server - the old panel drops the row as well.
          if (error?.response?.status === 404) {
            removeQuantityRow(item);
            return;
          }
          store.dispatch("showToaster", {
            type: "error",
            content: "Nie udało się usunąć nakładu.",
          });
        });
    };

    const groupPrices = (item) => {
      if (!canViewOptionPrice.value) {
        store.dispatch("showToaster", {
          type: "error",
          content: productoptionpricePermissionsConst.view.errorMsg,
        });
        return;
      }
      groupPricesPk.value = item.option;
      editingOptionPricePk.value = null;
      mGroupPrices.value = true;
    };

    // Main image picker like cp-input-file of the old panel - a picked file
    // is previewed locally, a saved image is shown from its URL.
    const imageInput = ref(null);
    const localImageUrl = ref("");
    const imagePreview = computed(() => {
      if (localImageUrl.value) {
        return localImageUrl.value;
      }
      return typeof productObj.value.image === "string"
        ? productObj.value.image
        : "";
    });

    const setLocalImageUrl = (file) => {
      if (localImageUrl.value) {
        window.URL.revokeObjectURL(localImageUrl.value);
      }
      localImageUrl.value = file ? window.URL.createObjectURL(file) : "";
    };

    const openImagePicker = () => {
      imageInput.value?.click();
    };

    const changePhoto = (event) => {
      const file = event.target.files?.[0];
      event.target.value = "";
      if (!file) {
        return;
      }
      productObj.value.image = file;
      setLocalImageUrl(file);
    };

    // An empty value tells the backend to clear the saved image; a saved image
    // left untouched is its URL, which the store action does not send.
    const removePhoto = () => {
      productObj.value.image = "";
      setLocalImageUrl(null);
    };

    onBeforeUnmount(() => setLocalImageUrl(null));

    const format = (date) => {
      if (date) {
        let day, month, year;
        day = date.getDate();
        month = ("0" + (date.getMonth() + 1)).slice(-2);
        year = date.getFullYear();

        return `${day}.${month}.${year}`;
      }
    };
    const parseCustomDate = (dateStr) => {
      const [date] = dateStr.split(" ");
      const [day, month, year] = date.split(".");
      const formattedDate = `${year}-${month}-${day}`;
      return new Date(formattedDate);
    };

    const exportPricesLoading = ref(false);
    const exportFile = () => {
      if (exportPricesLoading.value) {
        return;
      }
      exportPricesLoading.value = true;
      store
        .dispatch("exportProductPrices", { pk: route.params?.pk })
        .catch(() => {
          store.dispatch("showToaster", {
            type: "error",
            content: "Nie udało się wyeksportować nakładów.",
          });
        })
        .finally(() => {
          exportPricesLoading.value = false;
        });
    };

    const onFileChange = (e) => {
      const files = e.target.files || e.dataTransfer.files;
      excelFile.value = files.length ? files[0] : "";
    };

    // Mirrors ProductImportPricesModalController: rows the import could not
    // match are listed in the modal, and closing it after an import reloads the
    // product.
    const unassignedCols = [
      { title: "ID", value: "cell" },
      { title: "Nakład", value: "quantity" },
      { title: "Nakład wyświetlany", value: "display_quantity" },
      { title: "Cena nakładu", value: "price" },
      { title: "Dni realizacji", value: "realization_days" },
      { title: "ID opcji", value: "option_id" },
      { title: "Cena opcji", value: "option_price" },
    ];
    const unassignedRows = ref([]);
    const importPricesUploading = ref(false);
    const importPricesDone = ref(false);

    const importFileFn = () => {
      if (
        !canAddProduct.value ||
        !excelFile.value ||
        importPricesUploading.value
      ) {
        return;
      }
      importPricesUploading.value = true;
      importPricesDone.value = false;
      store
        .dispatch("importProductPrices", {
          excel_file: excelFile.value,
          pk: route.params?.pk,
        })
        .then((response) => {
          unassignedRows.value = response.data?.unassigned_rows || [];
          if (!unassignedRows.value.length) {
            store.dispatch("showToaster", {
              type: "success",
              content: "Import nakładów zakończył się pomyślnie.",
            });
          }
        })
        .catch(showResponseError)
        .finally(() => {
          importPricesUploading.value = false;
          importPricesDone.value = true;
        });
    };

    const closeImportPrices = () => {
      importFile.value = false;
      if (importPricesDone.value) {
        store.dispatch("getProduct", { pk: route.params?.pk });
      }
      importPricesDone.value = false;
      unassignedRows.value = [];
      excelFile.value = "";
    };

    // Mirrors ProductLogApplyModalController: a successful import closes the
    // modal and reloads the product, so a later save does not send stale option
    // groups back.
    const applyLogLoading = ref(false);
    const importFileProdFn = () => {
      if (
        !canAddProduct.value ||
        !importProduct.value ||
        applyLogLoading.value
      ) {
        return;
      }
      applyLogLoading.value = true;
      store
        .dispatch("importProductPQ", {
          product: importProduct.value,
          pk: route.params?.pk,
        })
        .then(() => {
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane produktu zostały zaktualizowane!",
          });
          importFileProd.value = false;
          importProduct.value = null;
          store.dispatch("getProduct", { pk: route.params?.pk });
        })
        .catch(showResponseError)
        .finally(() => {
          applyLogLoading.value = false;
        });
    };

    // The parameter and option listboxes need both the product and the
    // dictionaries, so they are built once both have arrived, in any order.
    const buildParameterLists = () => {
      if (parametersData.value?.status !== 200 || !productObj.value?.pk) {
        return;
      }
      const assigned = (productObj.value.parameters || []).map(
        (parameter) => parameter.parameter
      );
      parameters.value = [];
      selParameters.value = [];
      (parametersData.value.data || []).forEach((element) => {
        const item = {
          Name: "[" + element.pk + "] " + element.name,
          Code: element.pk,
        };
        if (assigned.includes(element.pk)) {
          selParameters.value.push(item);
        } else {
          parameters.value.push(item);
        }
      });
      filteredParams.value = [...parameters.value];
      selFilteredParameters.value = [...selParameters.value];
    };

    const buildOptionLists = () => {
      if (
        adminProductOptionsData.value?.status !== 200 ||
        !productObj.value?.pk
      ) {
        return;
      }
      const assigned = productObj.value.options || [];
      pOptions.value = [];
      selectedOptions.value = [];
      (adminProductOptionsData.value.data || []).forEach((element) => {
        const item = {
          Name:
            "[" +
            element.options_group +
            "] " +
            element.options_group_name +
            " [" +
            element.pk +
            "] " +
            element.label,
          Code: element.pk,
          value: element.pk,
        };
        if (assigned.includes(element.pk)) {
          selectedOptions.value.push(item);
        } else {
          pOptions.value.push(item);
        }
      });
      pOptionsFiltered.value = [...pOptions.value];
      pOptionsSelFiltered.value = [...selectedOptions.value];
    };

    const tooltipRef = ref(null);
    const lastHoveredElement = ref();

    const generateCheckboxesHtml = (checkboxes, pk) => {
      let html = "";
      const selectedOptions = (paramOptions.value[pk] || []).map((id) =>
        String(id)
      );
      for (const cb of checkboxes) {
        const isChecked = selectedOptions.includes(String(cb.pk));
        html += `
          <label style="display:block; margin-bottom:4px;">
            <input type="checkbox" data-id="${cb.pk}" data-pk="${pk}"
            ${isChecked ? "checked" : ""} />
            ${cb.name}
          </label>`;
      }

      return html;
    };

    const onItemChange = (event) => {
      const targetElement = event.event.target.closest(".e-list-item");
      if (!targetElement) return;

      if (lastHoveredElement.value === targetElement) {
        tooltipRef.value.ej2Instances.close();
        lastHoveredElement.value = null;
      } else {
        lastHoveredElement.value = targetElement;
        const selectedItem = event.value[0];
        const itemData = parametersData.value.data.find(
          (i) => i.pk === selectedItem
        );
        nextTick(() => {
          const selectedEl = document.querySelector(
            ".listbox2 .e-list-item.e-selected"
          );

          tooltipRef.value.ej2Instances.content = `<div>
            <h4>${itemData.name}</h4>
            <p>${generateCheckboxesHtml(itemData.options, itemData.pk)}</p>
          </div>`;
          tooltipRef.value.ej2Instances.open(selectedEl);
        });
      }
    };

    const onCheckboxChange = (e) => {
      const pk = e.target.dataset.pk;
      const id = normalizeOptionId(e.target.dataset.id);

      if (!paramOptions.value[pk]) {
        paramOptions.value[pk] = [];
      }

      const index = paramOptions.value[pk].indexOf(id);
      if (index === -1) {
        paramOptions.value[pk].push(id);
      } else {
        paramOptions.value[pk].splice(index, 1);
      }
    };

    const onTooltipAfterOpen = () => {
      const tooltipEl = document.querySelector(".e-tooltip-wrap");
      if (tooltipEl) {
        tooltipEl
          .querySelectorAll("input[type='checkbox']")
          .forEach((input) => {
            input.addEventListener("change", onCheckboxChange);
          });
      }
    };

    const onFiltering = (e) => {
      const searchText = (e.text || "").toLowerCase();
      if (searchText === "") {
        filteredParams.value = [...parameters.value];
      } else {
        filteredParams.value = parameters.value.filter((item) =>
          (item.Name || "").toLowerCase().includes(searchText)
        );
      }
      e.updateData(filteredParams.value, new Query(), fields);
    };

    const onFilteringSel = (e) => {
      const searchText = (e.text || "").toLowerCase();
      if (searchText === "") {
        selFilteredParameters.value = [...selParameters.value];
      } else {
        selFilteredParameters.value = selParameters.value.filter((item) =>
          (item.Name || "").toLowerCase().includes(searchText)
        );
      }
      e.updateData(selFilteredParameters.value, new Query(), fields);
    };

    const onFilteringP = (e) => {
      const searchText = (e.text || "").toLowerCase();
      if (searchText === "") {
        pOptionsFiltered.value = [...pOptions.value];
      } else {
        pOptionsFiltered.value = pOptions.value.filter((item) =>
          (item.Name || "").toLowerCase().includes(searchText)
        );
      }
      e.updateData(pOptionsFiltered.value, new Query(), fields);
    };

    const onFilteringPSel = (e) => {
      const searchText = (e.text || "").toLowerCase();
      if (searchText === "") {
        pOptionsSelFiltered.value = [...selectedOptions.value];
      } else {
        pOptionsSelFiltered.value = selectedOptions.value.filter((item) =>
          (item.Name || "").toLowerCase().includes(searchText)
        );
      }
      e.updateData(pOptionsSelFiltered.value, new Query(), fields);
    };

    store.dispatch("getProduct", { pk: route.params?.pk });
    // Material files are searched on the server by name and the next page is
    // loaded while a dropdown is scrolled, like the material ui-selects of the
    // old panel. The five selects share the first request.
    const materialKeys = [
      "materials_pl",
      "materials_en",
      "materials_de",
      "materials_cpde",
      "materials_cpen",
    ];
    const toMaterialOption = (element) => ({
      name: "[" + element.pk + "] " + element.name,
      value: element.pk,
    });
    const materialSelects = reactive(
      Object.fromEntries(
        materialKeys.map((key) => [
          key,
          usePagedSelect({
            fetchPage: ({ page, query }) =>
              store.dispatch("searchProductMaterials", {
                productPk: route.params?.pk,
                name: query,
                page,
              }),
            toOption: toMaterialOption,
            getSelected: () => productObj.value[key],
          }),
        ])
      )
    );
    store
      .dispatch("searchProductMaterials", { productPk: route.params?.pk })
      .then((response) => {
        materialKeys.forEach((key) =>
          materialSelects[key].setFirstPage(response)
        );
      })
      .catch(() => {});

    const toOptions = (response, labelKey) =>
      (Array.isArray(response?.data) ? response.data : []).map((element) => ({
        name: "[" + element.pk + "] " + element[labelKey],
        value: element.pk,
      }));

    store
      .dispatch("fetchProductPackageOptions")
      .then((response) => {
        packages.value = toOptions(response, "name");
      })
      .catch(() => {});
    store
      .dispatch("fetchProductCategoryParents")
      .then((response) => {
        categories.value = toOptions(response, "title");
      })
      .catch(() => {});
    store
      .dispatch("fetchProductAppliances")
      .then((response) => {
        appliances.value = toOptions(response, "name");
      })
      .catch(() => {});
    store
      .dispatch("fetchProductFormatOptions")
      .then((response) => {
        formats.value = (
          Array.isArray(response?.data) ? response.data : []
        ).map((element) => ({
          name:
            "[" + element.pk + "] " + element.size_x + " x " + element.size_y,
          value: element.pk,
        }));
      })
      .catch(() => {});
    // Products to import the group/option log from are searched on the server
    // and paged while scrolling, like the product picker of the old apply log
    // modal.
    const importProductSelect = reactive(
      usePagedSelect({
        fetchPage: ({ page, query }) =>
          store.dispatch("searchProductsOptionsList", { page, query }),
        toOption: (element) => ({
          name: "[" + element.pk + "] " + element.name,
          value: element.pk,
        }),
        getSelected: () => importProduct.value,
      })
    );
    importProductSelect.reload();
    store.dispatch("getProductOptions");
    store.dispatch("getProductPages");
    store.dispatch("getAdminParameters");
    store.dispatch("getAdminProductOptions");
    store.dispatch("getpOptionsAdminGroup");

    watch(
      () => productData.value,
      function (newValue) {
        productObj.value = newValue.data;
        // A reloaded product shows its saved image, not a file picked before.
        setLocalImageUrl(null);
        paramOptions.value = {};
        (productObj.value.parameters || []).forEach((parameter) => {
          paramOptions.value[parameter.parameter] = (
            parameter.parameter_options || []
          ).map((id) => normalizeOptionId(id));
        });
        if (newValue.data.date_to) {
          date_to.value = parseCustomDate(newValue.data.date_to);
        }
        if (newValue.data.date_from) {
          date_from.value = parseCustomDate(newValue.data.date_from);
        }
        buildParameterLists();
        buildOptionLists();
      }
    );

    watch(
      () => updatePriceDetailData.value,
      function (newValue) {
        if (newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Cena została zaktualizowana!",
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }
          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => updateProductsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          router.push({ name: "ProductsList", path: "/products" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Dane produktu zostały zaktualizowane!",
            });
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }
          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => productOptionsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          newValue.data?.forEach((element) => {
            options.value.push({
              name: element[1],
              value: element[0],
            });
          });
        }
      }
    );

    watch(
      () => pagesData.value,
      function (newValue) {
        if (newValue.status === 200) {
          pages.value = (newValue.data || []).map((element) => ({
            name: "[" + element.pk + "] " + element.title_seo,
            value: element.pk,
          }));
        }
      }
    );

    watch(() => parametersData.value, buildParameterLists);
    watch(() => adminProductOptionsData.value, buildOptionLists);

    return {
      imageInput,
      imagePreview,
      openImagePicker,
      exportPricesLoading,
      unassignedCols,
      unassignedRows,
      importPricesUploading,
      closeImportPrices,
      applyLogLoading,
      removePhoto,
      galleryInput,
      galleryDragOver,
      openGalleryPicker,
      onGalleryDragOver,
      onGalleryDrop,
      excelFile,
      canViewGallery,
      canAddGallery,
      canDeleteGallery,
      uploadGalleryImages,
      deleteGalleryImage,
      groupsToAdd,
      optionsToAdd,
      availableGroups,
      availableGroupOptions,
      groupOptionsForPageNum,
      isGroupExpanded,
      toggleGroup,
      onGroupDragStart,
      onGroupDrop,
      onOptionDragStart,
      onOptionDrop,
      syncSelectedOptions,
      canAddProduct,
      canChangeProduct,
      canViewQuantity,
      canAddQuantity,
      canDeleteQuantity,
      canViewOptionGroup,
      canAddOptionGroup,
      canDeleteOptionGroup,
      canAddOption,
      canDeleteOption,
      canViewOptionPrice,
      canChangeOptionPrice,
      productObj,
      errorsAdminData,
      showErrors,
      saveEdit,
      mGroups,
      mOptions,
      addGroup,
      isEdit,
      saveQuantity,
      quantityCols,
      newQuantity,
      editingQuantityPk,
      quantityDraft,
      quantityErrors,
      quantitySaving,
      startNewQuantity,
      saveNewQuantity,
      startEditQuantity,
      cancelQuantityEdit,
      canChangeQuantity,
      quantityPriceRows,
      editingPricePk,
      priceDraft,
      startEditPrice,
      removeQuantity,
      cancelQuantity,
      removeOption,
      materialSelects,
      options,
      formats,
      format,
      packages,
      categories,
      pages,
      appliances,
      countries,
      parameters,
      fields,
      toolbarSettings,
      pOptions,
      selectedOptions,
      addGroupOptions,
      quantityPriceHeaders,
      removeGroup,
      addOption,
      openOptionsModal,
      quantityPrices,
      mQuantityPrices,
      mGroupPrices,
      groupPrices,
      groupPricesPk,
      saveOptionPrice,
      changePhoto,
      optionPriceRows,
      editingOptionPricePk,
      optionPriceDraft,
      startEditOptionPrice,
      selParameters,
      date_from,
      date_to,
      importFile,
      importFileProd,
      exportFile,
      onFileChange,
      importFileFn,
      importProductSelect,
      importFileProdFn,
      importProduct,
      savePriceDetail,
      onItemChange,
      tooltipRef,
      onCheckboxChange,
      onTooltipAfterOpen,
      onFiltering,
      onFilteringSel,
      filteredParams,
      selFilteredParameters,
      pOptionsSelFiltered,
      pOptionsFiltered,
      onFilteringPSel,
      onFilteringP,
      filteredOptions,
    };
  },
  computed: {},
};
</script>
<style>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
</style>

<style scoped>
.drag-column {
  width: 30px;
  cursor: move;
  color: #999;
}
.product-image-preview {
  width: 200px;
  height: 150px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.product-image-preview img {
  max-width: 100%;
  max-height: 100%;
}
.product-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  min-height: 140px;
  padding: 10px;
  border: 2px dashed #e7eaec;
}
.product-gallery-clickable {
  cursor: pointer;
}
.product-gallery-dragover {
  border-color: #1ab394;
  background: #f3fbf9;
}
.product-gallery-item {
  position: relative;
}
.product-gallery-item img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 1px solid #e7eaec;
}
.product-gallery-remove {
  position: absolute;
  top: 4px;
  right: 4px;
}
</style>
